<template>
  <div>
    <label v-if="getTitle" class="label">
      <template v-if="!setTitleAsPlaceholder">{{ getTitle }}</template>
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>

    <osm-map ref="map" :marker="marker" :marker-draggable="true" :tiles-url="tilesUrl" :zoom="zoom" :center="center" :lat-model="model.Lat" :lng-model="model.Lng" />

    <w-error v-if="showError" :model="model" @focus="$refs.input.focus()"></w-error>

    <w-warning v-if="showWarning && !(showError && model.$error)" :model="model" @focus="$refs.input.focus()"></w-warning>
  </div>
</template>

<script>
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet/dist/leaflet.css';

import OsmMap from '@witkac/osm-map';

import modelMixin from '../mixins/modelMixin';

export default {
  props: {
    zoom: Number,
    center: Array
  },
  components: {OsmMap},
  mixins: [modelMixin],
  data() {
    return {
      tilesUrl: 'https://osm.cloud.witkac.pl/tiles/{z}/{x}/{y}.png'
    };
  },
  computed: {
    marker() {
      return {lat: this.model.Lat.$model, lng: this.model.Lng.$model};
    }
  }
};
</script>
